import { useContext, useEffect, useState } from "react"
import { AppContext } from "../App"
import { PiBuildingOfficeBold, PiStudent } from "react-icons/pi";
import { formatMoney, formatMoneyShorten } from "../Helpers";
import { FaChalkboardTeacher } from "react-icons/fa";
import { SiGoogleclassroom } from "react-icons/si";
import { IoIosPeople } from "react-icons/io";
import { getInlineLoader } from "../Helpers";
import banner1 from '../assets/banner1.jpg';
import banner2 from '../assets/banner2.jpeg';
import banner3 from '../assets/banner3.jpg';
import banner4 from '../assets/banner4.jpg';
import banner5 from '../assets/banner5.jpg';
import logo_icon from '../assets/logo_icon.png';
import { MdLocationPin, MdSearch } from "react-icons/md";
import OneHotelFeed from "./OneHotelFeed";

export default function HomeBanner2(props) {

	const appContext = useContext(AppContext);

	/* Place states here */
	const [ ready, setReady ] = useState(false);

	async function init() {
		//run initializations here
		setReady(false);
		//..
		await Promise.all([
			appContext.getAvailableHotels(),
		])
		setReady(true);
	}

	useEffect(() => {
		init();
	}, [ ])

	if(ready) {
		return (
			<div 
				className="MainBodySection"
				style={{
					paddingBottom: "50px",
					paddingTop: "50px"
				}}
			>
				<div className="container">
					<div className="row">
						<div className="col-md-12">
							<h6
								className="main-section-title"
							>
								Available Hotels
							</h6>
						</div>

						{
							(appContext.availableHotels && appContext.availableHotels.length > 0) ?
							<>
								{
									appContext.availableHotels.slice(0, 8).map((item, i) => {
										return (
											<div
												className={(i <= 1) ? "col-md-6" : "col-md-4"}
												key={i}
											>
												<OneHotelFeed data={item} />
											</div>
										)
									})
								}

								<div className="col-md-12 text-end">
									<button
										className="btn text-dark font-bold"
										onClick={() => {
											appContext.navTo({
												item: "hotels"
											})
										}}
									>
										Discover More Hotels....
									</button>
								</div>

							</>
							:
							<div className="col-md-12">
								<h6>No hotels were found</h6>
							</div>
						}

					</div>
				</div>
			</div>
		)
	} else {
		return (
			<div 
				className="container mSupportLoading"
			>
				{getInlineLoader()}
			</div>
		);
	}

	
}